<template>
  <div>
    <page-title>Events</page-title>

    <tabs v-if="$route.meta.isAdmin">
      <tabs-item
        :key="adminTabs.indexOf(tab)"
        v-for="tab in adminTabs"
        :link="tab.to"
        >{{ tab.title }}</tabs-item
      >
    </tabs>
    <tabs v-else>
      <tabs-item :key="tabs.indexOf(tab)" v-for="tab in tabs" :link="tab.to">{{
        tab.title
      }}</tabs-item>
    </tabs>

    <section-block>
      <template slot="header">
        <filter-bar :showSearch="true" resource="Events" />
      </template>
      <template slot="actions" v-if="$route.meta.isAdmin">
        <base-button
          :primary="true"
          @click="$router.push({ name: 'AdminEventsCreate' })"
          v-if="userCanAdd"
          >Add Event</base-button
        >
      </template>

      <vuetable
        class="c-data-table"
        :api-mode="false"
        :fields="table.fields"
        :data="events"
        @vuetable:row-clicked="onRowClicked"
      >
        <template slot="date-created" slot-scope="props">
          <base-datetime :date="props.rowData.created_time"></base-datetime>
        </template>

        <template slot="category-actions" slot-scope="props">
          <news-actions
            routePath="AdminEventsEdit"
            previewRoute="EventsSinglePage"
            :id="props.rowData.id"
            deleteAction="Events/delete"
            publishAction="Events/approve"
            rejectAction="Events/reject"
            type="event"
            :rowData="props.rowData"
          />
        </template>
      </vuetable>
    </section-block>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import NewsActions from '@/components/actions/NewsActions';
import UserHasPermission from '@/mixins/UserHasPermission';
export default {
  components: {
    NewsActions,
  },
  mixins: [UserHasPermission],
  data() {
    return {
      table: {
        fields: [
          {
            name: 'title',
            titleClass: 'u-ta-left',
            title: 'Event Name',
            width: '30%',
          },
          {
            name: 'status',
            titleClass: 'u-ta-left',
            title: 'Status',
            width: '20%',
          },
          {
            name: 'location.name',
            titleClass: 'u-ta-left',
            title: 'Event Location',
            width: '20%',
          },
          {
            name: 'start_date',
            titleClass: 'u-ta-left',
            title: 'Event Date',
            width: '20%',
          },
          {
            name: 'category-actions',
            title: 'Actions',
            titleClass: 'u-ta-center u-hide-mobile',
            dataClass: 'u-ta-center u-hide-mobile',
            width: '10%',
          },
        ],
      },
    };
  },

  computed: {
    ...mapState('Events', ['events']),
    userCanAdd() {
      return this.userHasPermission('add_edit_news');
    },
    adminTabs() {
      const vm = this;
      return [
        {
          to: `/admin/events`,
          title: `Approved`,
        },
        {
          to: `/admin/events/pending`,
          title: 'Awaiting Approval',
        },
        {
          to: `/admin/events/rejected`,
          title: `Rejected`,
        },
      ];
    },
  },

  methods: {
    onRowClicked(dataItem, event) {
      if (dataItem.event.target.localName === 'td' || dataItem.event.target.parentNode.localName === 'td') {
        this.$router.push({
          name: 'AdminEventsEdit',
          params: { id: dataItem.data.id },
        });
      }
    },
  },

  created() {
    if (this.$route.params.tabFilter) {
      this.$store.commit('Events/setTabFilter', [this.$route.params.tabFilter]);
    } else {
      this.$store.commit('Events/setTabFilter', [
        'approved',
        'published',
        'draft',
      ]);
    }
    this.$store.commit('Events/SET_PUBLISHED_FILTER', false);
    this.$store.dispatch('Events/list', { isFlat: true });
  },
};
</script>

<style scoped>
/**
 * TODO: Figure out why vuetable is doing a td within a td
 **/
td > td {
  border: 0;
  margin: 0;
  padding: 0;
  display: block;
}
</style>
